import { render, staticRenderFns } from "./action-type.vue?vue&type=template&id=1b1e33e4&"
import script from "./action-type.vue?vue&type=script&lang=js&"
export * from "./action-type.vue?vue&type=script&lang=js&"
import style0 from "./action-type.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports